export const ENVIRONMENT_API_URL = "/api/v1/calendar";
export const YOUTUBE_API_URL = "/api/v1/youtube";
export const CAMPAIGN_API_URL = "/api/v1/campaign";
export const ACTIVITY_API_URL = "/api/v1/activity";
export const HISTORY_API_URL = "/api/v1/history";
export const MEDIA_LIST_API = "/api/v1/media";
export const MEMBER_API = "/api/v1/member";
export const ACCOUNT_REPORT_API_URL = "/api/v1/account-report";
export const FILE_DOWNLOAD_API_URL = "/api/v1/file";
export const EXECUTIVE_LIST_API_URL = "/api/v1/executive";
export const HOME_BANNER_API_URL = "/api/v1/home-banner";
export const USER_API_URL = "/api/v1/user";

export const USER_SIGN_IN_API_URL = "/api/v1/user/login";
export const CHANGE_PASSWORD_API_URL = "/api/v1/user/password";
export const RESET_PASSWORD_API_URL = "/api/v1/user/password/reset";
export const REFRESH_TOKEN_API_URL = "/api/v1/token/refresh";
export const FIND_USER_ACCOUNT_API_URL = "/api/v1/user/account";
export const CHECK_EMAIL_API_URL = "/api/v1/user/check-user-email";
export const SEND_CODE_API_URL = "/api/v1/sms/send";
export const FIND_SEND_CODE_API_URL = "/api/v1/sms/send/test";
export const CHECK_CODE_API_URL = "/api/v1/sms/verify";
export const SHORT_FORM_CONTEST_PARTICIPATE_API_URL =
  "/api/v1/short-form-contest";

export const CONTEST_65_SECONDS_PARTICIPATE_API_URL =
  "/api/v1/contest-65-seconds";
